import { Code, ConnectError } from '@connectrpc/connect';

export function streamSleep(ms: number, signal: AbortSignal): Promise<void> {
  return new Promise((resolve, reject) => {
    const id = setTimeout(resolve, ms);
    signal.addEventListener(
      'abort',
      () => {
        clearTimeout(id);
        reject();
      },
      { once: true },
    );
  });
}

export function isNonRetriable(err: unknown): boolean {
  if (err instanceof ConnectError) {
    return (
      err.code === Code.Unauthenticated ||
      err.code === Code.PermissionDenied ||
      err.code === Code.NotFound ||
      err.code === Code.InvalidArgument
    );
  }
  return false;
}
